import { useQuery } from 'react-query';

import { isExternalReviewVersion } from '@common/app-manager';

import { checkExternalReview } from '../graphql/external_review_list.2';
import { checkValidCatalogProductId } from '../util/checkValidCatalogProductId';

export const useCheckExternalReviewQuery = (product_id: string) => {
  const { data } = useQuery(
    ['checkExternalReview', product_id],
    () => checkExternalReview({ product_id }, { show_alert: false }),
    {
      enabled: checkValidCatalogProductId(product_id) && isExternalReviewVersion(),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      staleTime: 60 * 1000 * 10,
    },
  );

  return {
    is_exposed: data?.data.external_product_review?.is_exposed ?? false,
  };
};
